const ApiRoute = "/MVC/AgentPortal";
export default ApiRoute;
